module.exports = __webpack_public_path__ + "static/media/CU.b22f4e4b.png";